<template>
  <section v-if="state.context.customer" :class="$options.name" class="tw:flex flex-column tw:gap-6">
    <EdroneInput
      :label="trans._inbox.customer.system.ip"
      :placeholder="trans._inbox.customer.system.placeholders.noData"
      :value="state.context.customer.system.ip || ''"
      disabled
      unique-id="0057332a-7074-4618-8caf-e08e305e0b5c"
    />
    <EdroneInput
      :label="trans._inbox.customer.system.emailStatusReason"
      :placeholder="trans._inbox.customer.system.placeholders.noData"
      :value="state.context.customer.system.subscriptionStatusReason || ''"
      disabled
      unique-id="12209d5f-a91d-4033-978c-5814bc463864"
    >
      <template #tooltip>
        <EdroneTooltip
          position="top"
          trigger-event="mouseenter click"
          type="custom"
          unique-id="b5dcdd08-f3ef-4408-a385-5c984b4db204"
        >
          <template #custom>
            <p class="tw:caption">
              {{ trans._inbox.customer.system.helpers.emailStatusReason }}
              <EdroneButtonIcon
                size="small"
                type="link"
                unique-id="da370338-090d-4115-a85f-d782d2a72f71"
                @click="goToDoc"
              >
                <font-awesome-icon icon="fa-light fa-link" />
              </EdroneButtonIcon>
            </p>
          </template>
        </EdroneTooltip>
      </template>
    </EdroneInput>
    <EdroneInput
      :label="trans._inbox.customer.system.smsStatusReason"
      :placeholder="trans._inbox.customer.system.placeholders.noData"
      :value="state.context.customer.system.smsSubscriptionStatusReason || ''"
      disabled
      unique-id="bcb3180c-dfbf-4ad8-8e4c-2c5ed889aa82"
    >
      <template #tooltip>
        <EdroneTooltip
          position="top"
          trigger-event="mouseenter click"
          type="custom"
          unique-id="c3e8078c-fd41-4693-818f-edbbf0710705"
        >
          <template #custom>
            <p class="tw:caption">
              {{ trans._inbox.customer.system.helpers.smsStatusReason }}
              <EdroneButtonIcon
                size="small"
                type="link"
                unique-id="bda91165-b06b-4222-9ffb-95e390d7e8dd"
                @click="goToDoc('sms')"
              >
                <font-awesome-icon icon="fa-light fa-link" />
              </EdroneButtonIcon>
            </p>
          </template>
        </EdroneTooltip>
      </template>
    </EdroneInput>
    <EdroneInput
      :label="trans._inbox.customer.system.whatsappStatusReason"
      :placeholder="trans._inbox.customer.system.placeholders.noData"
      :value="state.context.customer.system.whatsappSubscriptionStatusReason || ''"
      disabled
      unique-id="bcb3180c-dfbf-4ad8-8e4c-2c5ed889aa82"
    >
      <template #tooltip>
        <EdroneTooltip
          position="top"
          trigger-event="mouseenter click"
          type="custom"
          unique-id="c3e8078c-fd41-4693-818f-edbbf0710705"
        >
          <template #custom>
            <p class="tw:caption">
              {{ trans._inbox.customer.system.helpers.whatsappStatusReason }}
              <EdroneButtonIcon
                size="small"
                type="link"
                unique-id="bda91165-b06b-4222-9ffb-95e390d7e8dd"
                @click="goToDoc('whatsapp')"
              >
                <font-awesome-icon icon="fa-light fa-link" />
              </EdroneButtonIcon>
            </p>
          </template>
        </EdroneTooltip>
      </template>
    </EdroneInput>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useCustomerPreviewActor } from "vue-app/pages/machines/machineCustomerPreview";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import EdroneInput from "edrone-components/EdroneInput.vue";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";

export default defineComponent({
  name: "CustomerPreviewSystem",
  components: {
    EdroneButtonIcon,
    EdroneInput,
    EdroneTooltip,
  },
  setup() {
    const { state } = useCustomerPreviewActor();

    function goToDoc(type: "email" | "sms" | "whatsapp" = "email") {
      if (type === "email") {
        window.open("https://docs.edrone.me/subscriptions-status-reason.html", "_blank");
      }
      if (type === "sms") {
        window.open("https://docs.edrone.me/subscriptions-status-reason-sms.html", "_blank");
      }
      if (type === "whatsapp") {
        window.open("https://docs.edrone.me/subscriptions-status-reason-whatsapp.html", "_blank");
      }
    }

    return {
      state,
      goToDoc,
    };
  },
});
</script>

<style lang="scss" scoped></style>
